module.exports = __webpack_public_path__ + "img/lg_ring_y_0_1_0.b7e3a2cc.png";